// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/cdil-back.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hero {
  /* height: 520px; */
    /* IMAGE + GRADIENT OVERLAY */
  background:
    linear-gradient(
      to bottom,
      rgba(3, 78, 162, 0.92) 0%,
      rgba(2, 40, 63, 0.92) 100%
    ),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___});

  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: grid;
  align-items: center;
  padding-bottom: 0;
}   

.hero-content {
  text-align: center;
  color: #fff;
  max-width: 900px;
  padding-top: 150px;
  padding-bottom: 80px;
  margin: auto;
}

.hero h1 {
  font-size: 45px;
  font-weight: 700;
  margin-bottom: 12px;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.hero p {
     margin-bottom: 16px;
    --tw-text-opacity: 1;
    color: rgb(229 231 235 / var(--tw-text-opacity, 1));
    font-size: 18px;
    line-height: 1.75rem;
}

.hero-search {
  display: flex;
  background: #fff;
  padding: 6px;
  border-radius: 14px;
  max-width: 42rem;
  max-height: 49px;
  margin: auto;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.3);
  position: relative;
}

.hero-search input {
  flex: 1 1;
  border: none;
  padding: 16px;
  font-size: 14px;
  outline: none;
}

.hero-search button {
  background: #034EA2;
  color: #fff;
  border: none;
  padding: 0 28px;
  border-radius: 10px;
  font-weight: 600;
  cursor: pointer;
}

.hero-popular {
  margin-top: 18px;
  font-size: 0.9rem;
  color: #e5e7eb;
  display: ruby;
}

.hero-popular span {
  margin: 0 6px;
}
.hero-search-results {
  position: absolute;
  top: calc(100% + 6px);
  left: 50%;
  transform: translateX(-50%);
  width: 668px;
  max-height: 180px;
  background: rgb(255 255 255 / 98%);
  border-radius: 10px;
  box-shadow: 0 5px 5px rgba(0, 0, 0, 0.4);
  overflow-y: auto;
  z-index: 9999;
}

/* Individual result */
.hero-search-item {
  display: flex;
  gap: 10px;
  padding: 10px 16px;
  color: #ffffff;
  text-decoration: none;
  font-size: 15px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.hero-search-item:last-child {
  border-bottom: none;
}

.hero-search-item:hover {
  background: rgba(255, 255, 255, 0.08);
}

.hero-search-item .dot {
  color: #9ca3af;
}

.hero-search-item .type {
  opacity: 0.75;
}

/* Prevent page scroll jump */
.hero {
  position: relative;
  overflow: visible;
}

/* Mobile */
@media (max-width: 768px) {
  .hero-search-results {
    width: 94%;
  }
}



/*header fix*/


`, "",{"version":3,"sources":["webpack://./src/assets/styles/hero.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;IACjB,6BAA6B;EAC/B;;;;;;2CAM2C;;EAE3C,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mDAAmD;AACrD;;AAEA;KACK,mBAAmB;IACpB,oBAAoB;IACpB,mDAAmD;IACnD,eAAe;IACf,oBAAoB;AACxB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,eAAe;EACf,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,iBAAiB;EACjB,kCAAkC;EAClC,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;EAChB,aAAa;AACf;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,WAAW;AACX;EACE;IACE,UAAU;EACZ;AACF;;;;AAIA,aAAa","sourcesContent":[".hero {\r\n  /* height: 520px; */\r\n    /* IMAGE + GRADIENT OVERLAY */\r\n  background:\r\n    linear-gradient(\r\n      to bottom,\r\n      rgba(3, 78, 162, 0.92) 0%,\r\n      rgba(2, 40, 63, 0.92) 100%\r\n    ),\r\n    url(\"../../assets/images/cdil-back.webp\");\r\n\r\n  background-size: cover;\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n  display: grid;\r\n  align-items: center;\r\n  padding-bottom: 0;\r\n}   \r\n\r\n.hero-content {\r\n  text-align: center;\r\n  color: #fff;\r\n  max-width: 900px;\r\n  padding-top: 150px;\r\n  padding-bottom: 80px;\r\n  margin: auto;\r\n}\r\n\r\n.hero h1 {\r\n  font-size: 45px;\r\n  font-weight: 700;\r\n  margin-bottom: 12px;\r\n  color: rgb(255 255 255 / var(--tw-text-opacity, 1));\r\n}\r\n\r\n.hero p {\r\n     margin-bottom: 16px;\r\n    --tw-text-opacity: 1;\r\n    color: rgb(229 231 235 / var(--tw-text-opacity, 1));\r\n    font-size: 18px;\r\n    line-height: 1.75rem;\r\n}\r\n\r\n.hero-search {\r\n  display: flex;\r\n  background: #fff;\r\n  padding: 6px;\r\n  border-radius: 14px;\r\n  max-width: 42rem;\r\n  max-height: 49px;\r\n  margin: auto;\r\n  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.3);\r\n  position: relative;\r\n}\r\n\r\n.hero-search input {\r\n  flex: 1;\r\n  border: none;\r\n  padding: 16px;\r\n  font-size: 14px;\r\n  outline: none;\r\n}\r\n\r\n.hero-search button {\r\n  background: #034EA2;\r\n  color: #fff;\r\n  border: none;\r\n  padding: 0 28px;\r\n  border-radius: 10px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n}\r\n\r\n.hero-popular {\r\n  margin-top: 18px;\r\n  font-size: 0.9rem;\r\n  color: #e5e7eb;\r\n  display: ruby;\r\n}\r\n\r\n.hero-popular span {\r\n  margin: 0 6px;\r\n}\r\n.hero-search-results {\r\n  position: absolute;\r\n  top: calc(100% + 6px);\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  width: 668px;\r\n  max-height: 180px;\r\n  background: rgb(255 255 255 / 98%);\r\n  border-radius: 10px;\r\n  box-shadow: 0 5px 5px rgba(0, 0, 0, 0.4);\r\n  overflow-y: auto;\r\n  z-index: 9999;\r\n}\r\n\r\n/* Individual result */\r\n.hero-search-item {\r\n  display: flex;\r\n  gap: 10px;\r\n  padding: 10px 16px;\r\n  color: #ffffff;\r\n  text-decoration: none;\r\n  font-size: 15px;\r\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\r\n}\r\n\r\n.hero-search-item:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.hero-search-item:hover {\r\n  background: rgba(255, 255, 255, 0.08);\r\n}\r\n\r\n.hero-search-item .dot {\r\n  color: #9ca3af;\r\n}\r\n\r\n.hero-search-item .type {\r\n  opacity: 0.75;\r\n}\r\n\r\n/* Prevent page scroll jump */\r\n.hero {\r\n  position: relative;\r\n  overflow: visible;\r\n}\r\n\r\n/* Mobile */\r\n@media (max-width: 768px) {\r\n  .hero-search-results {\r\n    width: 94%;\r\n  }\r\n}\r\n\r\n\r\n\r\n/*header fix*/\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
